import { NgModule } from '@angular/core';
import { ChartDefaults } from './chartdefaults';
import { BasicLineComponent } from './basicline';
import { BasicAreaComponent } from './basicarea';
import { SplineComponent } from './spline';
import { StackedColumnComponent } from './stackedcolumn';
import { ColumnComponent } from './column';

@NgModule({
    imports: [],
    declarations: [BasicLineComponent, BasicAreaComponent, SplineComponent, StackedColumnComponent, ColumnComponent],
    exports: [BasicLineComponent, BasicAreaComponent, SplineComponent, StackedColumnComponent, ColumnComponent],
    providers: [ChartDefaults]
})
export class ChartsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/charts/charts.module.ts